<template>
  <v-container>
    <v-row v-if="$auth.isAuthenticated">
      <v-col cols="12" class="text-center">
        <v-btn :disabled="$workSessions.lmraLocked" class="h-50" :dark="!$workSessions.lmraLocked" block color="primary"
               to="lmra">{{ $vuetify.lang.t('$vuetify.menu.lmra') }}
        </v-btn>

        <v-btn class="h-50" dark block color="primary" to="report_incident">
          {{ $vuetify.lang.t('$vuetify.menu.report_incident') }}
        </v-btn>

        <!-- TODO REMOVE DISABLED AND RE-ADD DARK -->
        <v-btn v-if="appSettings.usesNearIncidentReports" class="h-50" block color="primary" to="report_near_incident"
               disabled><!-- dark -->
          {{ $vuetify.lang.t('$vuetify.menu.report_near_incident') }}
        </v-btn>

        <v-btn v-if="appSettings.usesRiskAnalysis" class="h-50" dark block color="primary" to="risk_analysis">
          {{ $vuetify.lang.t('$vuetify.menu.risk_analysis') }}
        </v-btn>

        <v-btn v-if="appSettings.usesCoronaRiskAnalysisVariant" class="h-50" dark block color="primary"
               to="corona_analysis">{{ $vuetify.lang.t('$vuetify.menu.corona_analysis') }}
        </v-btn>

        <v-btn v-if="appSettings.usesReportProcessIssue" class="h-50" dark block color="primary"
               to="process_issue">{{ $vuetify.lang.t('$vuetify.menu.process_issue') }}
        </v-btn>

        <v-btn v-if="appSettings.usesQRCodeScanner" class="h-50" dark block color="cyan" to="scan_qr">
          {{ $vuetify.lang.t('$vuetify.menu.scan_qr') }}
        </v-btn>

        <v-btn class="h-50" dark block color="primary" to="checklist">
          {{ $vuetify.lang.t('$vuetify.menu.checklist') }}
        </v-btn>

        <v-btn class="h-50" dark block color="warning" to="emergency_numbers">
          <v-icon dark style="padding-right: 10px;">
            mdi-phone
          </v-icon> {{ $vuetify.lang.t('$vuetify.menu.emergency_numbers') }}
        </v-btn>

        <div v-if="appSettings.usesWhatsAppGroups">
          <whatsapp-group-button></whatsapp-group-button>
        </div>

        <v-btn class="h-50" dark block color="red" @click="logout()">
          {{ $vuetify.lang.t('$vuetify.menu.log_out') }}
        </v-btn>

        <v-btn class="text-center data-notice-btn" text v-if="displayDataNotice"
               @click="display_data_notice()">{{ $vuetify.lang.t('$vuetify.data_notice.button_text') }}
        </v-btn>
      </v-col>
      <v-col>
        <p style="font-size:10px;" class="text-center">
          logged in as : {{ ($auth.user && $auth.user.email) ? $auth.user.email : 'loading' }}
        </p>
        <p style="font-size:10px;" class="text-center">info APP. LMRA: <a href="mailto:info@lmra.be"
                                                                          target="_blank"
                                                                          :style="{ 'color': `${appSettings.colors.accent}`}"

        >info@lmra.be</a><br/><br/>visit
          us: <a href="https://www.riskreflex.com" target="_blank" :style="{ 'color': `${appSettings.colors.accent}`}">www.riskreflex.com</a><br/><br/><small><i>Methodology
            Copyright protected number 2016/5849</i></small> <br/><br/>v.{{ versionNumber }} <br/> build: {{buildNumber}}<br/><br/><span :class="versionWarningClasses">{{ versionInfoText }}</span></p>

      </v-col>
    </v-row>
    <v-row v-if="!$auth.isAuthenticated">
      <v-col cols="12">
        <login-form @userLoggedIn="promptGDPRPopup"></login-form>
      </v-col>
      <!-- TODO CHECK THIS STUFF AND HOW TO HANDLE IT -->
      <v-col cols="12" v-if="this.$store.getters.getHasAuth0UnverifiedEmailErrorState">
        <v-alert type="error">
          {{ $vuetify.lang.t('$vuetify.errors.auth0.unverified_email.error') }}
        </v-alert>
        <v-alert type="warning" v-html="$sanitize(
                unverifiedEmailInfo(), {
                allowedTags: ['b','br','i']
                })">
        </v-alert>
      </v-col>
    </v-row>
    <simple-popup :is-visible="(show_simple_popup && !$workSessions.loading)"
                  :title="simple_popup_title"
                  :body="simple_popup_body"
                  :custom_positive_btn_text="simple_popup_positive_btn_txt"
                  :display_negative_btn="simple_popup_has_negative_btn"
                  :custom_negative_btn_text="simple_popup_negative_btn_txt"
                  @negative_btn_clicked="close_popup_negative()"
                  @positive_btn_clicked="close_popup_positive()"
    ></simple-popup>
  </v-container>
</template>

<script>
import {mobileCheckMixin} from "./../mixins/MobileCheckMixin/MobileCheckMixin";
import appSettings from "../mixins/config/appSettings"
import SimplePopupComponent from "../components/modules/global/simplePopup/SimplePopupComponent";
import {version, buildNumber} from '../../package'
import WhatsappGroupButton from "../components/misc/whatsApp/WhatsappGroupButton";
import loginForm from "@/components/auth/loginForm";

import VueCookies from 'vue-cookies';
import {AppVersionHelper} from "@/helpers/version/AppVersionHelper";

const GDPR_COOKIE_NAME = 'USER-ACCEPTED-GDPR-POLICY'

export default {
  name: "Home",
  mixins: [mobileCheckMixin, appSettings],
  components: {
    simplePopup: SimplePopupComponent,
    WhatsappGroupButton,
    loginForm
  },
  data: () => {
    return {
      versionNumber: 'unknown',
      buildNumber: 'unknown',
      data_notice_vuetify_selector: '$vuetify.data_notice.popup_body',
      gdpr_popup_is_shown: false,
      show_simple_popup: false,
      simple_popup_title: '',
      simple_popup_body: '',
      simple_popup_has_negative_btn: false,
      simple_popup_negative_btn_txt: '',
      simple_popup_positive_btn_txt: '',
      versionWarningClasses : '',
      versionInfoText : ''
    }
  },
  methods: {
    logout() {
      this.$auth.logout();
    },
    display_data_notice() {
      this.simple_popup_title = this.$vuetify.lang.t('$vuetify.data_notice.popup_title');
      this.simple_popup_body = this.$vuetify.lang.t('$vuetify.data_notice.popup_body');
      this.simple_popup_has_negative_btn = false;
      this.show_simple_popup = true;
    },
    display_gdpr_proposal() {
      this.gdpr_popup_is_shown = true;
      this.simple_popup_title = this.$vuetify.lang.t('$vuetify.gdpr_disclaimer.title');
      this.simple_popup_body = this.$vuetify.lang.t('$vuetify.gdpr_disclaimer.body');
      this.simple_popup_has_negative_btn = true;
      this.simple_popup_negative_btn_txt = this.$vuetify.lang.t('$vuetify.gdpr_disclaimer.decline_btn');
      this.simple_popup_positive_btn_txt = this.$vuetify.lang.t('$vuetify.gdpr_disclaimer.accept_btn');
      this.show_simple_popup = true;
    },
    hide_simple_popup() {
      this.simple_popup_has_negative_btn = false;
      this.simple_popup_negative_btn_txt = '';
      this.simple_popup_positive_btn_txt = '';
      this.show_simple_popup = false;
    },
    getCookieName() {
      return GDPR_COOKIE_NAME + '-' + this.$store.state.user_id
    },
    close_popup_positive() {
      if (this.gdpr_popup_is_shown) {
        //console.log('SET THAT DAMNED COOKIE...');
        VueCookies.set(this.getCookieName(), 'USER-DID-ACCEPT-GDPR-COOKIE', "90d");
        this.gdpr_popup_is_shown = false;
      }
      this.hide_simple_popup();
    },
    close_popup_negative() {
      this.hide_simple_popup();
      this.$auth.logout();
    },
    //MOVE TO LOGIN
    promptGDPRPopup() {
      let gdpr_cookie = VueCookies.get(this.getCookieName());
      if (gdpr_cookie === null) {
        if (!this.show_simple_popup) {
          this.display_gdpr_proposal();
        }
      }
    },
    unverifiedEmailInfo() {
      return this.$vuetify.lang.t('$vuetify.errors.auth0.unverified_email.info').replace('|SENDER|', this.appSettings.verificationEmailSender);
    },
    doVersionCheck(){
      let info = this.$store.getters.getWebAppVersionInfo;
      if((info.minimum_required_version !== null && info.latest_version !== null)){
          if(AppVersionHelper.isNewerVersion(this.versionNumber, info.minimum_required_version)){
            this.versionInfoText = this.$vuetify.lang.t('$vuetify.version_info.update.update_required');
            this.versionWarningClasses = 'version-update-required';
          }else {
            if (AppVersionHelper.isNewerVersion(this.versionNumber, info.latest_version)) {
              this.versionInfoText = this.$vuetify.lang.t('$vuetify.version_info.update.version_minor_update');
              this.versionWarningClasses = 'version-minor-update';
            } else {
              this.versionInfoText = this.$vuetify.lang.t('$vuetify.version_info.update.version_up_to_date');
              this.versionWarningClasses = 'version-up-to-date';
            }
          }
      }
    }
  },
  async created() {
    this.versionNumber = version;
    this.buildNumber = buildNumber;
    this.doVersionCheck();
    if (this.$auth.isAuthenticated) {
      window.console.log('CREATED AGAIN');
      if (!this.$auth.userKnown && !this.$auth.loading) {
        await this.$auth.getUser();
      }
      this.promptGDPRPopup();
      this.$store.dispatch('getUserLocation');
    }


    /*console.log('UMCAP = ' + this.appSettings.usesManagedClientsAndProjects);
    console.log('UC-MCAP = ' + this.appSettings.usesCombinedManagedCAP);*/

  },
  computed: {
    displayDataNotice() {
      let dataNoticeBody = this.$vuetify.lang.t(this.data_notice_vuetify_selector);
      if (dataNoticeBody.length > 0 && dataNoticeBody !== this.data_notice_vuetify_selector) {
        return true;
      }
      return false;
    }
  },

  watch: {
    //ONLY WATCH REQUIRED SINCE IT's The most important one!
    '$store.state.latestVersionInfo': function() {
      this.doVersionCheck();
    }
  },

  beforeDestroy() {
    this.$store.dispatch('getUserLocation');
  }
}
</script>

<style scoped>
.data-notice-btn {
  font-size: 12px;
  color: #999999;
  text-decoration: underline;
}
span.version-up-to-date{
  color: seagreen !important;
}
span.version-update-required{
  color: white;
  background-color: #fb8c00;
  padding: 5px 12px;
}
span.version-minor-update{
  color: seagreen !important;
}
</style>